import React from "react";
import { Box, useTheme } from "@mui/material";
import { AlertSeverity } from "../../../../../models/Alerts/Alert";
import {
  AlertTone,
  SEVERITY_LABELS,
  getAlertColors,
  getSeverityTone,
} from "./alertUi";

interface AlertPillProps {
  label: React.ReactNode;
  tone?: AlertTone;
  mono?: boolean;
  dot?: boolean;
}

export const AlertPill: React.FC<AlertPillProps> = ({
  label,
  tone,
  mono = false,
  dot = false,
}) => {
  const theme = useTheme();
  const colors = getAlertColors(theme);
  const resolved = tone ?? {
    fg: colors.subtitle,
    bg: colors.surfaceMuted,
    border: colors.border,
  };

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        height: 22,
        px: 1,
        borderRadius: "999px",
        fontSize: "0.7rem",
        fontWeight: 600,
        lineHeight: 1,
        whiteSpace: "nowrap",
        color: resolved.fg,
        bgcolor: resolved.bg,
        border: `1px solid ${resolved.border}`,
        fontFamily: mono
          ? "ui-monospace, SFMono-Regular, Menlo, monospace"
          : "inherit",
        letterSpacing: mono ? "0.01em" : "normal",
      }}
    >
      {dot && (
        <Box
          component="span"
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            bgcolor: resolved.fg,
          }}
        />
      )}
      {label}
    </Box>
  );
};

export const SeverityPill: React.FC<{ severity: AlertSeverity }> = ({
  severity,
}) => {
  const theme = useTheme();
  return (
    <AlertPill
      label={SEVERITY_LABELS[severity]}
      tone={getSeverityTone(theme, severity)}
      dot
    />
  );
};
